import { CartItem } from 'src/features/common/types/application/cart';
import { Address, Application, PriceType } from '../types';

/**
 * Get all the products that are being delivered to a specific address.
 * @param {Address} address - The address
 * @param {Application} application - Application state.
 */
export const getProductsFromAddress = (address: Address, application: Application) => {
  const deliveries = (application.deliveries ?? []).filter(
    (delivery) => delivery.addressId === address.id,
  );

  const products = deliveries.map((delivery) => {
    const cartItem = (application.cart ?? []).find(
      (cartItem) => cartItem.productId === delivery.productId,
    );

    if (!cartItem) {
      throw new Error(
        `Exception error: delivery ${JSON.stringify(delivery)}: has no product ${JSON.stringify(
          cartItem,
        )} `,
      );
    }

    return { id: cartItem.productId, quantity: cartItem.quantity };
  });

  return products;
};

export function calculateTotalCartQuantity(cart: CartItem[]): number {
  return cart.reduce((total, item) => total + item.quantity, 0);
}

export function calculateCartTotal(cart: CartItem[]): number {
  return cart.reduce((total, item) => {
    return total + (item.price || 0) * item.quantity;
  }, 0);
}

export function isItemInCart(cart: CartItem[], id: string): boolean {
  return cart.some(item => item.productId === id);
}

export function isECommerceItemInCart(cart: CartItem[], name: string): boolean {
  return cart.some(item => item.title === name);
}

export function filterCartItemsByPriceType(cart: CartItem[], priceType: PriceType): CartItem[] {
  return cart.filter(item => item.priceType === priceType);
}